<template>
  <div>
    <section class="message-area">
      <div class="chat-area">
        <div class="chatlist">
          <div class="modal-content">
            <div class="chat-header">
              <div class="msg-search">
                <input
                  type="search"
                  inputmode="search"
                  enterkeyhint="search"
                  class="form-control"
                  placeholder="جستجو"
                  v-model="fillter.term"
                  @keyup.enter="handleSearch"
                />
                <div class="searchBtn" @click="handleSearch">
                  <VsxIcon
                    iconName="SearchNormal1"
                    :size="16"
                    color="#000"
                    type="linear"
                  />
                </div>
              </div>

              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: fillter.main_category === 'all' }"
                    @click="setActiveTab('all')"
                  >
                    همه چت ها
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: fillter.main_category === 'trade' }"
                    @click="setActiveTab('trade')"
                  >
                    فروش
                  </button>
                </li>
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: fillter.main_category === 'rent' }"
                    @click="setActiveTab('rent')"
                  >
                    اجاره
                  </button>
                </li>
              </ul>
            </div>

            <div class="chat-lists" style="padding-bottom: 24px">
              <el-scrollbar @scroll="handleScroll">
                <div v-if="LoadingSkeleton" class="tab-pane fade show">
                  <div class="chat-list" v-for="(u, i) in 5" :key="i">
                    <Skeletor
                      class="user-bio-name userbioSkeletor userProfileSkeletor"
                      style="
                        width: 50px;
                        border-radius: 100%;
                        height: 50px;
                        background: rgb(230, 241, 240);
                        margin-right: 8px;
                      "
                    />
                    <Skeletor
                      class="user-bio-name userbioSkeletor"
                      style="
                        width: 76%;
                        border-radius: 5px;
                        height: 50px;
                        margin-right: 8px;
                        background: rgb(230, 241, 240);
                        margin-right: 8px;
                      "
                    />
                  </div>
                </div>

                <div
                  v-if="!LoadingSkeleton && chat_list.length > 0"
                  class="tab-pane fade show"
                >
                  <div
                    class="chat-list"
                    v-for="(user, index) in chat_list"
                    :key="index"
                    @click="
                      openChat(
                        'first',
                        user.receiver_id,
                        user.main_category,
                        index,
                        user.id,
                        user.is_sender,
                        user.sender_id
                      )
                    "
                    :class="{ 'active-user': activeUserId === user.id }"
                  >
                    <div class="flex-shrink-0">
                      <img
                        class="img-fluid"
                        :src="getAvatar(user)"
                        alt="تصویر کاربر"
                        @error="handleImageError"
                      />
                      <!--                      <span v-if="user.active" class="active"></span>-->
                    </div>
                    <div class="flex-grow-1 ms-3">
                      <h3>{{ user.receiver }}</h3>
                      <p class="last-message">{{ user.last_msg }}</p>
                      <p
                        class="last-message"
                        style="margin-top: 10px"
                        v-if="fillter.main_category === 'all'"
                      >
                        {{ user.main_category_fa }}
                      </p>
                    </div>
                  </div>

                  <span v-if="loadmore_loading" class="loader"></span>
                </div>
                <div
                  v-if="!LoadingSkeleton && chat_list.length == 0"
                  class="tab-pane fade show"
                >
                  <div class="noResultThumb">
                    <div class="thumbPic">
                      <img src="/img/notfound.png" alt="">
                    </div>
                    <div class="thumbContent">
                      لیست چت شما خالی است!
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
          </div>
        </div>

        <div class="chatbox" v-if="currentChat">
          <div class="modal-dialog-scrollable">
            <div class="modal-content">
              <div class="msg-head">
                <div class="row">
                  <div class="col-8">
                    <div class="AllClassShowToUSerProfile">
                      <div class="ClassShowToUSerProfile" @click="showUserProfile">
                        <div class="flex-shrink-0">
                          <img
                            class="img-fluid"
                            :src="getAvatar(currentChat)"
                            alt="تصویر کاربر"
                            @error="handleImageError"
                          />
                        </div>
                        <h3>{{ currentChat.receiver }}</h3>
                      </div>

                      <div class="ClassShowToUSerProfile">
                        <span class="chat-icon" @click.stop="closeChat()">
                          <VsxIcon
                            iconName="Back"
                            :size="32"
                            color="red"
                            type="linear"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <el-scrollbar class="modal-body1">
                <div class="msg-body">
                  <ul style="display: flex; flex-flow: column-reverse">
                    <li
                      v-for="(msg, index) in chat_room_list"
                      :key="index"
                      :class="msg.owner == 'me' ? 'repaly' : 'sender'"
                    >
                      <p v-if="msg.content_type == 'text'">{{ msg.content }}</p>

                      <div
                        v-else-if="msg.content_type === 'file'"
                        class="file-message"
                      >
                        <div class="file-info">
                          <i class="fa-solid fa-file-pdf"></i>
                          <div class="file-details">
                            <span class="file-name">{{ msg.content }}</span>
                            <!--                            <span class="file-size">{{ msg.fileSize }}</span>-->
                          </div>
                        </div>
                        <!--                        <a :href="msg.fileUrl" download class="download-btn">-->
                        <!--                          <VsxIcon iconName="DocumentDownload" :size="23" color="#5584FF" type="bold" />-->
                        <!--                        </a>-->
                      </div>

                      <div
                        v-else-if="msg.content_type === 'image'"
                        class="image-message"
                        @click="openImageModal(msg)"
                      >
                        <img :src="msg.fileUrl" :alt="msg.text" />
                        <div class="image-info">
                          <span class="file-name">{{ msg.content }}</span>
                          <!--                          <span class="file-size">{{ msg.fileSize }}</span>-->
                          <button
                            class="download-btn"
                            @click.stop="downloadImage(msg)"
                          >
                            <VsxIcon
                              iconName="DocumentDownload"
                              :size="23"
                              color="green"
                              type="bold"
                            />
                          </button>
                        </div>
                      </div>

                      <span class="time"
                        ><span v-if="msg.status == 'not_seen'" class="msgSeen">
                          <svg
                            width="800px"
                            height="800px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 12.6111L8.92308 17.5L20 6.5"
                              stroke="#000000"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </span>
                        <span v-else class="msgSeen"
                          ><svg
                            width="800px"
                            height="800px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 12.9L7.14286 16.5L15 7.5"
                              stroke="#000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M20 7.5625L11.4283 16.5625L11 16"
                              stroke="#000"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            /></svg></span
                        >{{ msg.created_at_fa }}</span
                      >
                    </li>
                  </ul>
                </div>
              </el-scrollbar>
              <div class="fastMessage">
                <Swiper :slides-per-view="'auto'" class="fastMessageContainer">
                  <SwiperSlide v-for="(m, i) in fastMessages" :key="i">
                    <div class="fastMessageBox" @click="fastMessageHandler(m)">
                      {{ m }}
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div class="send-box">
                <form @submit.prevent="sendMessage">
                  <div class="sendInput">
                    <input
                      type="text"
                      class="form-control"
                      v-model="msg_form.message"
                      placeholder="پیام را بنویسید…"
                    />
                  </div>

                  <button type="submit" v-show="msg_form.message !== ''">
                    <i v-if="!sending" class="fa-solid fa-paper-plane"></i>
                    <span v-if="sending" class="loader"></span>
                  </button>
                  <button
                    type="submit sendFile"
                    v-show="msg_form.message === ''"
                  >
                    <input
                      type="file"
                      ref="fileInput"
                      accept="image/*"
                      @change="previewImage"
                    />
                    <i class="fa-solid fa-paperclip"></i>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="chatbox chatBoxAlert" v-if="!currentChat">
          <div class="chatAlert">
            برای شروع پیام رسانی، یک گفتگو را انتخاب کنید
          </div>
        </div>
      </div>
    </section>

    <div v-if="showImageModal" class="image-modal" @click="closeImageModal">
      <div class="modal-content">
        <div class="modal-header">
          <div class="file-info">
            <span class="file-name">{{ selectedImage.text }}</span>
            <span class="file-size">{{ selectedImage.fileSize }}</span>
          </div>
          <div class="modal-actions">
            <button
              class="download-btn"
              @click.stop="downloadImage(selectedImage)"
            >
              <VsxIcon
                iconName="DocumentDownload"
                :size="21"
                color="#5584FF"
                type="bold"
              />
            </button>
            <button class="close-btn" @click="closeImageModal">
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
        </div>
        <img :src="selectedImage.fileUrl" :alt="selectedImage.text" />
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Skeletor } from "vue-skeletor";
import "swiper/css";
import Compressor from "compressorjs";
import axios from "axios";
export default {
  name: "systemChat",
  components: { Swiper, SwiperSlide, Skeletor },
  data() {
    return {
      searchTerm: "",
      LoadingSkeleton: true,
      sending: false,
      currentChat: null,
      activeUserId: null,
      fastMessages: [
        "سلام، وقت بخیر",
        "قیمت چنده؟",
        "آدرس دقیق کجاست؟",
        "عکس های بیشتر میفرستید؟",
        "نخفیف داره؟",
        "امکان بازدید هست؟",
      ],

      showImageModal: false,
      selectedImage: null,
      loadmore: false,
      loadmore_loading: false,
      fillter: {
        main_category: "all",
        term: "",
        page: 1,
        per_page: 10,
      },

      isLoading: false,
      chat_list: [],
      chat_fillter: {
        main_category: "",
        receiver_id: 0,
        page: 1,
        per_page: 10,
      },
      chat_room_list: [],
      msg_form: {
        message: "",
        receiver_id: 0,
      },
    };
  },
  watch: {
    "$route.query.uid": {
      handler(newVal) {
        if (!newVal) {
          this.currentChat = null;
          this.activeUserId = null;
        }
      }
    }
  },
  mounted() {
    this.load_chat_list("first");
  },
  methods: {
    getAvatar(user) {
      const fallback = "https://shomalamlak.ir/panel/back-end/img/profile.png";

      if (user.is_sender) {
        return user.receiver_role === "branch_admin"
          ? user.branch_avatar || fallback
          : user.avatar || fallback;
      } else {
        return user.sender_role === "branch_admin"
          ? user.branch_avatar || fallback
          : user.avatar || fallback;
      }
    },
    handleImageError(event) {
      event.target.src =
        "https://shomalamlak.ir/panel/back-end/img/profile.png";
    },
    load_chat_list(param) {
      let self = this;
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.chat_list = [];
        this.fillter.page = 1;
        this.LoadingSkeleton = true;
      }
      console.log("chat");

      this.helperPost("chat-list", this.fillter).then((r) => {
        console.log("chat0", r.data);
        if (r.data.result == 0) {
          // this.chat_list = [];
          console.log("chat1");
          if (param != "first") {
            this.fillter.page -= 1;
          }
          if (self.$route.query.uid) {
            const currentChat = r.data.daata.list.filter(d => {
              d.receiver_id == this.$route.query.uid;
            })
            console.log('currentChat', currentChat)
            self.currentChat = {
              sender_id: self.$store.state.auth.uid,
              receiver_id: self.$route.query.uid,
              receiver: currentChat ? currentChat.receiver : "مخاطب",
              main_category: self.$route.query.main_cat,
              // 'avatar' : $avatar,
            };

            self.openChat(
              "first",
              self.$route.query.uid,
              self.$route.query.main_cat,
              -1,
              0,
              true
            );
          }
        } else {
          this.chat_list = this.chat_list.concat(r.data.data.list);
          if (r.data.data.total_page == this.fillter.page) {
            this.loadmore = false;
          }

          let finduser = false;
          console.log("chatList:", self.$route.query.uid);
          //بررسی وجود چت لیت وقتی از صفحه جزئیات میاد
          if (self.fillter.page == 1 && self.$route.query.uid) {
            self.chat_list.forEach(function (v, i) {
              if (v.is_sender) {
                if (
                  v.receiver_id == self.$route.query.uid &&
                  v.main_category == self.$route.query.main_cat
                ) {
                  console.log("finduser", finduser);
                  finduser = true;
                  self.openChat(
                    "first",
                    v.receiver_id,
                    v.main_category,
                    i,
                    v.id,
                    v.is_sender,
                    v.sender_id
                  );
                }
              } else {
                if (
                  v.sender_id == self.$route.query.uid &&
                  v.main_category == self.$route.query.main_cat
                ) {
                  console.log("finduser", finduser);
                  finduser = true;
                  self.openChat(
                    "first",
                    v.receiver_id,
                    v.main_category,
                    i,
                    v.id,
                    v.is_sender,
                    v.sender_id
                  );
                }
              }
            });
            if (!finduser) {
              this.currentChat = {
                sender_id: self.$store.state.auth.uid,
                receiver_id: self.$route.query.uid,
                receiver: "مخاطب",
                main_category: self.$route.query.main_cat,
                // 'avatar' : $avatar,
              };

              self.openChat(
                "first",
                self.$route.query.uid,
                self.$route.query.main_cat,
                -1,
                0,
                true
              );
            }
          }
        }
        this.LoadingSkeleton = false;
        this.isLoading = false;
        this.loadmore_loading = false;
      });
    },

    handleSearch() {
      this.load_chat_list("first");
    },

    showUserProfile() {
      if (!this.currentChat) return;
      if (this.currentChat.is_sender) {
        if (this.currentChat.receiver_role == 'branch_admin') {
          this.$router.push(`/profile-amlak?bid=${this.currentChat.receiver_branch_id}`)
        } else if (this.currentChat.receiver_role == 'builder') {
          this.$router.push(`/profile-builder?uid=${this.currentChat.receiver_id}`)
        } else {
          this.$router.push(`/profile-superior?uid=${this.currentChat.receiver_id}`)
        }
      } else {
        if (this.currentChat.sender_role == 'branch_admin') {
          this.$router.push(`/profile-amlak?bid=${this.currentChat.sender_branch_id}`)
        } else if (this.currentChat.sender_role == 'builder') {
          this.$router.push(`/profile-builder?uid=${this.currentChat.sender_id}`)
        } else {
          this.$router.push(`/profile-superior?uid=${this.currentChat.sender_id}`)
        }
      }
    },

    setActiveTab(tab) {
      this.fillter.main_category = tab;
      this.load_chat_list("first");
    },
    async openChat(
      param,
      receiver_id,
      main_category,
      index,
      chat_id,
      isSender,
      SenderID
    ) {
      console.log("main_category", main_category);
      this.loadmore = true;
      this.loadmore_loading = true;
      this.fillter.page += 1;
      if (param == "first") {
        this.isLoading = true;
        this.chat_room_list = [];
        this.fillter.page = 1;
      }
      if (!isSender) {
        this.chat_fillter.receiver_id = SenderID;
        this.msg_form.receiver_id = SenderID;
      } else {
        this.chat_fillter.receiver_id = receiver_id;
        this.msg_form.receiver_id = receiver_id;
      }
      this.chat_fillter.main_category = main_category;

      this.helperPost("chat-list-info", this.chat_fillter).then((r) => {
        if (r.data.result == 0) {
          // this.chat_room_list = [];
          if (param != "first") {
            this.fillter.page -= 1;
          }
        } else {
          this.chat_room_list = this.chat_room_list.concat(r.data.data.list);
          if (r.data.data.total_page == this.fillter.page) {
            this.loadmore = false;
          }

          if (index >= 0) this.currentChat = this.chat_list[index];
          if (chat_id) this.activeUserId = chat_id;

          this.msg_form.main_category = main_category;
          this.$router.push({
            path: this.$route.path,
            query: { uid: isSender ? receiver_id : SenderID, main_cat: main_category }
          });
        }
        this.isLoading = false;
        this.loadmore_loading = false;
      });
    },

    closeChat() {
      this.currentChat = null;
      this.activeUserId = null;
      this.$router.push({
        path: this.$route.path
      });
    },

    sendMessage() {
      if (this.msg_form.message.trim()) {
        console.log("this.msg_form", this.msg_form);
        this.sending = true;
        this.helperPost("chat-insert", this.msg_form).then((r) => {
          if (r.data.result == 1) {
            this.openChat(
              "first",
              this.msg_form.receiver_id,
              this.msg_form.main_category,
              -1,
              this.activeUserId,
              true
            );
            this.sending = false;
            this.msg_form.message = "";
          }
          this.sending = false;
        });
      }
    },
    handleScroll() {
      const scrollbarWrap = this.$refs.scrollbar?.wrapRef;

      if (!scrollbarWrap) return;

      const scrollTop = scrollbarWrap.scrollTop;
      const scrollHeight = scrollbarWrap.scrollHeight;
      const clientHeight = scrollbarWrap.clientHeight;

      // لیزی لود: اگر ۱۰۰ پیکسل مانده به انتهای لیست
      if (scrollTop + clientHeight + 100 >= scrollHeight) {
        if (this.loadmore && !this.loadmore_loading) {
          this.load_chat_list(); // متد لود داده‌هات
        }
      }
    },
    fastMessageHandler(message) {
      this.msg_form.message = message;
    },
    openImageModal(image) {
      this.selectedImage = image;
      this.showImageModal = true;
      document.body.style.overflow = "hidden"; // جلوگیری از اسکرول صفحه
    },
    closeImageModal() {
      this.showImageModal = false;
      this.selectedImage = null;
      document.body.style.overflow = "auto"; // برگرداندن اسکرول صفحه
    },
    async downloadImage(image) {
      try {
        const response = await fetch(image.fileUrl);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = image.text;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("خطا در دانلود تصویر:", error);
      }
    },
    formatFileSize(bytes) {
      if (!bytes) return "0 B";

      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));

      return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
    },
    // async handleFileUpload(file) {
    //   if (!file) return;
    //
    //   const fileSize = this.formatFileSize(file.size);
    //   const isImage = file.type.startsWith("image/");
    //
    //   // const message = {
    //   //   type: isImage ? "image" : "file",
    //   //   text: file.name,
    //   //   fileSize: fileSize,
    //   //   fileUrl: URL.createObjectURL(file),
    //   //   time: this.getPersianTime(),
    //   //   sender: true,
    //   // };
    //   //
    //   // this.currentChat.messages.push(message);
    // },

    openFileInput() {
      this.$refs.fileInput.click();
    },
    async previewImage(event) {
      var self = this;
      const file = event.target.files[0];
      if (!file) {
        return;
      }
      // this.formatFileSize(file.size);
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(file);

      new Compressor(file, {
        quality: 0.6,

        // The compression process is asynchronous,
        // which means you have to access the `result` in the `success` hook function.
        success(result) {
          const formData = new FormData();

          //formData.append("token", self.$store.getters.appToken);
          formData.append("message", "فایل");
          formData.append("receiver_id", self.msg_form.receiver_id);
          formData.append("main_category", self.msg_form.main_category);
          formData.append("file", result);

          axios
            .post(self.$store.getters.baseUrl + "/chat-insert", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: "Bearer " + self.$store.getters.appToken,
              },
            })
            .then(function (response) {
              console.log("response", response);
              if (response.data.result == 1) {
                self.openChat(
                  "first",
                  self.msg_form.receiver_id,
                  self.msg_form.main_category,
                  -1,
                  self.activeUserId,
                  true
                );
                self.sending = false;
                self.msg_form.message = "";
              }
              self.sending = false;
            });
        },
        error(err) {
          console.log(err.message);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content {
  position: relative;
}
.swiper {
  width: 100%;

  .swiper-slide {
    width: auto;
  }
}
.fastMessage {
  padding: 8px 0;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 60px;

  .fastMessageContainer {
    padding: 0 6px;
  }

  .fastMessageBox {
    cursor: pointer;
    border: none;
    line-height: 32px;
    display: inline-block;
    padding: 0 12px;
    font-size: 0.9rem;
    white-space: nowrap;
    border-radius: 10rem;
    margin-right: 8px;
    color: #0096c7;
    border: 1px solid #0096c7;
    background: #fff;
  }
}

@media (max-width: 600px) {
  .send-box .form-control {
    &:focus {
      border: 1px solid #eff0f1;
      box-shadow: none;
    }
  }
}

.msg-body ul li {
  &.sender {
    justify-content: flex-start;

    .file-message,
    .image-message,
    p {
      margin-right: auto;
      margin-left: 0;
    }

    .time {
      text-align: left;

      .msgSeen {
        display: block;
        margin-right: auto;
        width: fit-content;
      }
    }
  }

  &.repaly {
    justify-content: flex-end;

    .file-message,
    .image-message,
    p {
      margin-left: auto;
      margin-right: 0;
    }

    .time {
      text-align: right;
    }
  }
}

.file-message,
.image-message {
  width: 100%;
  max-width: 300px;
}

.file-message {
  background: #fff;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 10px;

  i {
    font-size: 24px;
    color: #dc3545;
  }

  .file-details {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .file-name {
      font-weight: 500;
      font-size: 14px;
      margin-bottom: 5px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .file-size {
      font-size: 12px;
      color: #6c757d;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.download-btn {
  color: #0096c7;
  padding: 5px;
  cursor: pointer;
  margin-bottom: 5px !important;

  &:hover {
    color: darken(#0096c7, 10%);
  }
}

.image-message {
  max-width: 300px;
  cursor: pointer;
  transition: opacity 0.2s;

  img {
    width: 100%;
    max-height: 400px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 5px;
  }

  .image-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #333;
    padding: 5px;

    .download-btn {
      color: #0096c7;
      padding: 5px;

      &:hover {
        color: darken(#0096c7, 10%);
      }
    }
  }
}

@media (max-height: 768px) {
  .image-message img {
    max-height: 300px;
  }
}

.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  .modal-content {
    max-width: 90%;
    max-height: 90vh;
    position: relative;

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: white;
      padding: 10px;

      .file-info {
        .file-name {
          margin-right: 10px;
          font-weight: 500;
          font-size: 14px;
        }

        .file-size {
          color: #fff;
        }
      }

      .modal-actions {
        display: flex;
        gap: 15px;

        .download-btn,
        .close-btn {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          font-size: 18px;
          margin-bottom: 5px !important;
          &:hover {
            color: #0096c7;
          }
        }
      }
    }

    img {
      max-width: 100%;
      max-height: 85vh;
      object-fit: contain;
    }
  }
}

.last-message {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.loader {
  height: 24px;
  width: 24px;
  margin-top: 0 !important;
}

.noResultThumb {
  width: 100%;

  .thumbPic {
    img {
      width: 80%;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .thumbContent {
    font-size: 0.95rem;
    text-align: center;
  }
}

.dark {
  .noResultThumb {
    .thumbContent {
      color: #fff;
    }
  }
}
</style>
